import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})



export class TimerService {

       public isForwarding:boolean = false;

       timer:any = null;
       interval:number;
       index:number = 0;
       callback:Function;
       timeout:any = null;

       startTime:number;

       public set(interval:number,callback:Function) {
              this.callback = callback;
              this.interval = interval*1000;
       }
       
       public check(interval:number,checkFunc:Function) {
              interval = interval * 1000;
              this.timeout = setInterval(() => {
                         checkFunc();
              },interval)
       }
     
       public reset() {

             this.pause();
             this.startTime = new Date().getTime();

             this.timer = setInterval(() => {

                  let passed = new Date().getTime() - this.startTime;

                  if ( this.index == 0 ) {
                       if ( passed >= this.interval*2 ) {
                            this.index = 2;
                            this.callback(this.index);      
                       }
                  }
                  else
                  if ( passed >= this.interval*3 ) this.callback(++this.index);
             },60000);
       }

       public pause() {
            if ( this.timer )  { 
                 clearInterval(this.timer);
                 this.timer = null;
            }
            this.index = 0;
       }

       public close() {

             if ( this.timeout )  { 
                  clearInterval(this.timeout);
                  this.timeout = null;
             }

             this.pause();
       }
}

